// extracted by mini-css-extract-plugin
export default {"audioselectscreen":"AudioSelectScreen_audioselectscreen__SA5S4","audioselectscreen-choices":"AudioSelectScreen_audioselectscreen-choices__Uo1G6"};